import React, { useState, useEffect, lazy, Suspense, useRef } from "react";
import ReactDOM from "react-dom";
import AuthService from "../../../class/services/AuthService";
// import Game from "../../../class/Game/Game";
import Games from "../../../class/Game_copy/Game";
import { useTranslation } from "react-i18next";
import { useWebSocket } from '../../../context/WebSocketContext';


const JackpotModal = lazy(() => import("../modal/modal_jackpot.js"));

const ModalLogin = lazy(() => import("../modal/modal_login.js"));

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "ws.xyztown.info";
// const SOCKET_GAME_URL = process.env.REACT_APP_SOCKET_GAME_URL || "ws.xyztown.info";

let openModal;

const ModalGame = ({
    setIsLogged,
    isLogged,
    openRegisterModal,
    isUserCashBlocked,
    setIsUserCashBlocked,
    setHomeReload,
}) => {
    const [show, setShow] = useState(false);
    const [gameId, setGameId] = useState(null);
    const [gameUrl, setGameUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const { isConnected, addListener, removeListener, sendMessage } = useWebSocket();

    const [showJackpot, setShowJackpot] = useState(false);
    const [jackpotAmount, setJackpotAmount] = useState(0);
    const [jackpotType, setJackpotType] = useState("");
    const [jackpotCurrency, setJackpotCurrency] = useState("EUR");

    const iframeRef = useRef(null);
    const { t } = useTranslation();

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleCloseModal = (modalType) => {
        setIsAnimating(true);
        setTimeout(() => {
            setIsLoginModalOpen(false);
            setIsAnimating(false);
        }, 300);
    };

    const [gameInfo, setGameInfo] = useState({
        game_name: "",
        provider_name: "",
    });

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    useEffect(() => {
        if (show && gameId && isLogged) {
            const fetchGameUrl = async () => {
                try {
                    const user_id = await AuthService.getCustom("user_id");

                    const currency = await AuthService.getCustom("currency");
                    console.log("Currency:", currency);

                    console.log("Game ID:", gameId);

                    const language = await AuthService.getCustom("lang");
                    console.log("LANG:", language);

                    const response = await Games.openGame(
                        currency,
                        gameId,
                        user_id,
                        language,
                    );
                    console.log("Game URL response:", response);

                    setGameInfo({
                        game_name: response.params.game_name,
                        provider_name: response.params.provider_name,
                    });
                    setGameUrl(response.params.url);

                    // StopAutomaticBalanceUpdate();
                } catch (error) {
                    console.error(`${t("Failed_to_fetch_game_URL")}:`, error);
                } finally {
                    setLoading(false);
                }
            };

            fetchGameUrl();
        }
    }, [show, gameId, isLogged]);

    const sendRefreshBalance = () => {
        const userId = AuthService.getCustom("user_id");
        const SKIN_ORDER = AuthService.getCustom("skin_order");


        const USER_ID = `${userId}_${SKIN_ORDER}`;
        const message = "CLOSEGAME|" + USER_ID + "|REFRESH_BALANCE";


        sendMessage(message);
    }

    const handleClose = () => {
        setShow(false);
        setGameId(null);
        setGameUrl("");
        setLoading(true);
        setGameInfo({ game_name: "", provider_name: "" });

        sendRefreshBalance();
    };

    // const StopAutomaticBalanceUpdate = async () => {
    //     try {
    //         const user_id = await AuthService.getCustom("user_id");

    //         fetch(`https://${SOCKET_URL}/stopbalance`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({ USER_ID: user_id }),
    //         });
    //     } catch (error) {
    //         console.error("Failed to stop automatic balance update:", error);
    //     }
    // };

    // const resumeAutomaticBalanceUpdate = async () => {
    //     try {
    //         const user_id = await AuthService.getCustom("user_id");

    //         fetch(`https://${SOCKET_URL}/resumebalance`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({ USER_ID: user_id }),
    //         });
    //     } catch (error) {
    //         console.error("Failed to resume automatic balance update:", error);
    //     }
    // };

    useEffect(() => {
        const checkIframeUrl = () => {
            try {
                if (
                    iframeRef.current?.contentWindow?.location?.hostname ===
                    "1x2play.com"
                ) {
                    handleClose();
                }
            } catch (error) {
                // Браузер блокує доступ до крос-доменних ресурсів
            }
        };

        const interval = setInterval(checkIframeUrl, 1000);

        return () => clearInterval(interval);
    }, [gameUrl]);

    // Функция для определения Safari
    const isSafari = () => {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    };

    // ...existing code...

    openModal = async (newGameId) => {
        if (isLogged && !show) {
            try {
                // Получаем инфу об игре
                const gameInfo = await Games.getGameInfo(newGameId);
                const gameType =
                    gameInfo?.params?.game_info[0]?.category_slug || "";

                // salvataggio giochi recenti
                if (gameType == "casino" || gameType == "casino-live") {
                    const user_id = await AuthService.getCustom("user_id");
                    const lastGames = await Games.updateLastGames(
                        user_id,
                        gameType,
                        newGameId,
                    );
                    // console.log("NUOVO GIOCO");
                    // console.log(lastGames);
                }

                // Safari + casino-live: открываем в новом окне
                if (
                    isSafari() &&
                    (gameType === "casino-live" || gameType === "casino_live")
                ) {
                    const user_id = await AuthService.getCustom("user_id");
                    const currency = await AuthService.getCustom("currency");
                    const language = await AuthService.getCustom("lang");

                    const response = await Games.openGame(
                        currency,
                        newGameId,
                        user_id,
                        language,
                    );
                    console.log("Game URL response:", response);
                    if (response?.url) {
                        window.open(response.params.url, "_blank");
                    } else {
                        console.error("Game URL not found");
                    }
                    return;
                }

                if (isConnected) {
                    addListener("JACKPOTWIN", (data) => {
                        console.log("Jackpot win detected:", data);
                        setJackpotAmount(parseFloat(parseFloat(data[1])).toFixed(2));
                        setJackpotType(data[0]);
                        setShowJackpot(true);
                        setJackpotCurrency(data[2]);
                    });
                }

                // Обычное поведение
                setShow(true);
                setGameId(newGameId);
            } catch (error) {
                console.error("Failed to fetch game info or open game:", error);
            }
        } else if (!isLogged) {
            setIsLoginModalOpen(true);
            console.error(t("User_is_not_logged_in."));
        }

        console.log("ModalGame opened with gameId:", [
            newGameId,
            isLogged,
            show,
            gameUrl,
        ]);
    };

    // ...existing code...

    /* openModal = (newGameId) => {
    if (isLogged && !show) {
      setShow(true);
      setGameId(newGameId);
    } else if (!isLogged) {
      setIsLoginModalOpen(true);
      console.error(t('User_is_not_logged_in.'));
    }
  }; */
    
    const handleCloseModalJackpot = () => {
        setShowJackpot(false);
    }

    return ReactDOM.createPortal(
        <>
            <div
                className={`modal gamebox fade ${show ? "show" : ""}`}
                style={{ display: show ? "block" : "none" }}
                tabIndex="-1"
                aria-labelledby="gameModalLabel"
                aria-hidden={!show}
            >
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-body">
                            <JackpotModal show={showJackpot} userClass={jackpotType} jackpotAmount={jackpotAmount} currency={jackpotCurrency} handleClose={handleCloseModalJackpot} />
                            <div
                                className="Home_header"
                                style={{ background: "#ddd" }}
                            >
                                <a
                                    href="#"
                                    className="HomeSection_header"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    style={{ cursor: "unset" }}
                                >
                                    <div
                                        className="HomeSection_label"
                                        style={{
                                            width: "100%",
                                            fontSize: "13px",
                                            fontWeight: "400",
                                            color: "#000000",
                                        }}
                                    >
                                        <span>
                                            <strong
                                                style={{
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {gameInfo.provider_name}
                                            </strong>{" "}
                                            - {gameInfo.game_name}
                                        </span>
                                    </div>

                                    <div
                                        className="HomeSection_icon"
                                        style={{ marginRight: "unset" }}
                                    >
                                        {/* <button onClick={toggleFullScreen} style={{ marginRight: "15px", background: "rgb(126 125 125 / 49%)", borderRadius: "50%", height: "25px", width: "25px", justifyContent: "center", alignItems: "center", display: "flex", padding: "3px"}}>
                    <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
                      <path style={{ color: "#fbc103" }} stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 4h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5"/>
                    </svg>
                  </button> */}

                                        <button
                                            onClick={handleClose}
                                            style={{
                                                background:
                                                    "rgb(126 125 125 / 49%)",
                                                borderRadius: "50%",
                                                height: "25px",
                                                width: "25px",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                display:
                                                    "flex" /* padding: "3px" */,
                                            }}
                                        >
                                            <svg
                                                className="w-6 h-6 text-gray-800 dark:text-white"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="18"
                                                height="18"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                style={{
                                                    transform:
                                                        "translateX(1px)",
                                                }}
                                            >
                                                <path
                                                    style={{ color: "#01143c" }}
                                                    stroke="currentColor"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    stroke-width="2.5"
                                                    d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </a>
                            </div>

                            {loading ? (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ height: "100%" }}
                                >
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                    >
                                        <span className="visually-hidden">
                                            {t("loading")}...
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <iframe
                                    src={gameUrl}
                                    title="Game Frame"
                                    frameBorder="0"
                                    style={{ display: "block" }}
                                ></iframe>
                            )}

                            {/* <div className="Home_header" onClick={handleClose}>
              <a href="#" className="HomeSection_header" data-bs-dismiss="modal" aria-label="Close">
                <div className="HomeSection_icon">
                  <div className="arrow left"></div>
                </div>
                <div className="HomeSection_label">{t('back')}</div>
                <div className="HomeSection_right"></div>
              </a>
            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {isLoginModalOpen && (
                <Suspense fallback={<div>{t("loading")}...</div>}>
                    <ModalLogin
                        setIsLogged={setIsLogged}
                        show={isLoginModalOpen && !isAnimating}
                        onClose={handleCloseModal}
                        isUserCashBlocked={isUserCashBlocked}
                        setIsUserCashBlocked={setIsUserCashBlocked}
                        setHomeReload={setHomeReload}
                        onOpenRegisterModal={() => {
                            handleCloseModal();
                            setTimeout(() => openRegisterModal(), 300);
                        }}
                    />
                </Suspense>
            )}
        </>,
        document.body,
    );
};

export const openGameModal = (gameId) => {
    if (typeof openModal === "function") {
        openModal(gameId);

        console.log("openGameModal called with gameId:", gameId);
    } else {
        console.error("ModalGame is not mounted yet.");
    }
};

export default ModalGame;
